import React, { useEffect, useState } from 'react';
import { SearchIcon, MessageSquareIcon, MusicIcon, UserIcon, UsersIcon, CalendarIcon } from 'lucide-react';
export const HowItWorksSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [selectedPath, setSelectedPath] = useState('teacher'); // Default to teacher path
  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('how-it-works');
      if (element) {
        const position = element.getBoundingClientRect();
        if (position.top < window.innerHeight * 0.75) {
          setIsVisible(true);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on initial load
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const studentSteps = [{
    icon: <SearchIcon className="h-8 w-8 text-deep-pink" data-id="element-1505" />,
    title: 'Browse Teachers',
    description: 'Discover teachers by instrument, city, zip code, or reviews.'
  }, {
    icon: <MessageSquareIcon className="h-8 w-8 text-deep-pink" data-id="element-1506" />,
    title: 'Connect',
    description: 'Chat with teachers and ask questions before you book.'
  }, {
    icon: <MusicIcon className="h-8 w-8 text-deep-pink" data-id="element-1507" />,
    title: 'Start Learning',
    description: 'Choose your teacher and begin lessons on your schedule.'
  }];
  const teacherSteps = [{
    icon: <UserIcon className="h-8 w-8 text-blue-600" data-id="element-1508" />,
    title: 'Create a Profile',
    description: 'Create a professional teaching profile with your experience, instruments, availability, and teaching details.'
  }, {
    icon: <UsersIcon className="h-8 w-8 text-blue-600" data-id="element-1509" />,
    title: 'Prepare your profile',
    description: 'Prepare your profile with teaching details, availability, and preferences, ready for future student discovery.'
  }, {
    icon: <CalendarIcon className="h-8 w-8 text-blue-600" data-id="element-1510" />,
    title: 'Start Teaching',
    description: 'Manage lessons and schedules, track progress, and run your teaching studio from one dashboard.'
  }];
  // Select the appropriate steps based on the selected path
  const steps = selectedPath === 'student' ? studentSteps : teacherSteps;
  return <section id="how-it-works" className="py-24 bg-white" data-id="element-1511">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1512">
        <div className="text-center mb-10" data-id="element-1513">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy-900 mb-4" data-id="element-1514">
            How MaestroConnect Works
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8" data-id="element-1515">
            {selectedPath === 'student' ? 'Finding the right music teacher has never been easier. Our platform simplifies the process in just three steps.' : 'MaestroConnect gives music teachers professional tools to manage lessons, students, and growth — with student discovery launching soon.'}
          </p>
          {/* Toggle buttons */}
          <div className="inline-flex bg-gray-100 rounded-lg p-1 mb-8" data-id="element-1516">
            <button onClick={() => setSelectedPath('teacher')} className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${selectedPath === 'teacher' ? 'bg-navy-800 text-white' : 'text-gray-700 hover:bg-gray-200'}`} data-id="element-1517">
              I'm a Teacher
            </button>
            <button onClick={() => setSelectedPath('student')} className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${selectedPath === 'student' ? 'bg-navy-800 text-white' : 'text-gray-700 hover:bg-gray-200'}`} data-id="element-1518">
              I'm a Student
            </button>
          </div>
        </div>
        {selectedPath === 'student' ? <div className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-1519">
            <div className="bg-gray-50 rounded-xl p-12 shadow-sm border border-gray-100 text-center max-w-3xl mx-auto" data-id="element-1520">
              <h3 className="text-2xl font-bold text-navy-900 mb-4" data-id="element-1521">
                Student Experience — Coming Soon
              </h3>
              <p className="text-lg text-gray-600" data-id="element-1522">
                Student discovery, booking, and messaging are launching soon.
                MaestroConnect is opening early access for teachers first to
                ensure high-quality profiles before student launch.
              </p>
            </div>
          </div> : <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1523">
            {steps.map((step, index) => <div key={`${selectedPath}-${index}`} className={`bg-gray-50 rounded-xl p-8 shadow-sm border border-gray-100 transition-all duration-700 delay-${index * 200} ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-1524">
                <div className="bg-lavender/10 rounded-full w-16 h-16 flex items-center justify-center mb-6" data-id="element-1525">
                  {step.icon}
                </div>
                <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-1526">
                  {step.title}
                </h3>
                <p className="text-gray-600" data-id="element-1527">{step.description}</p>
              </div>)}
          </div>}
      </div>
    </section>;
};